import React from 'react'
import Modal from '../../@Components/Modal/Modal';
import { Card } from '@material-ui/core';
import moment from 'moment';
import {formatAsCPFCNPJMasked, formatAsCPFCNPJ } from "../../Utils/utils"
import {titleCase, translateGender} from '../utils/utils'

function ModalNaturalPerson(props){

    const {closeModal, nameToSearch, personList, analyzedObj, setAnalyzedObj, onSubmit} = props

    return(
        <Modal 
            closeModal={closeModal}
            title="Consulta por Nome"
            >
            <div className='Modal_body_queryByName' style={{ display: 'flex'}}>
                <div className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                    style={{display: 'flex', justifyContent: 'start', margin: '40px'}}
                >
                    <strong style={{marginRight: '10px'}}>Exibindo resultados para:</strong>
                    <span>{nameToSearch}</span>
                </div>
                <div className='cardContainer' style={{margin: '0px 30px'}} >
                    <div className="listCardHeader" style={{display: 'grid',  gridTemplateColumns: '20% 20% 20% 20% 20%'}}>
                        <div className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}>
                            Nome
                        </div>
                        <div className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}>
                            Documento
                        </div>
                        <div className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}>
                            Gênero
                        </div>
                        <div className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}>
                            Data de Nascimento
                        </div>
                    </div>
                {personList['data'].map((natural_person, index) => (
                    <Card key={natural_person.document} className={["listCard","collapse"].join(" ")} >
                        <div style={{display: 'grid',  gridTemplateColumns: '20% 20% 20% 20% 20%'}}>
                            <div className={["listCardItem", "normalText", "subtitleSize"].join(" ")}>
                                {titleCase(natural_person.name)}
                            </div>
                            <div className={["listCardItem", "normalText", "subtitleSize"].join(" ")}>
                                {formatAsCPFCNPJMasked(natural_person.document)}
                            </div>
                            <div className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")} >
                                {translateGender(natural_person.gender)}
                            </div>
                            <div className={["listCardItem", "normalText", "subtitleSize"].join(" ")} 
                            style={{display: 'flex', flexDirection: 'column'}}>
                                <span>{moment(natural_person.date_of_birth).format("DD/MM/YYYY")}</span>
                                <span>{`${natural_person.age} anos`}</span>
                            </div>
                            <div className={["listCardItem", "normalText", "normalMediumSize", "bold"].join(" ")}>
                                {analyzedObj[index] ? 
                                <div className={"button standard disabled"}
                                    style={{minWidth: '100%'}}
                                >
                                    {"Solicitado"}
                                </div>
                                :
                                <div
                                    id={formatAsCPFCNPJ(natural_person.document)}
                                    onClick={(event) => {onSubmit(event); setAnalyzedObj({...analyzedObj, [index]: true})}} 
                                    className={"button standard "} 
                                    style={{minWidth: '100%'}}
                                >
                                    {"Analisar"}
                                </div>}
                            </div>
                        </div>
                    </Card>))}
                </div>
            </div>
        </Modal>

    )
}

export default ModalNaturalPerson